let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fLZEe")).then(() => parcelRequire('dy9iD'));